import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Button, notification } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { HeaderButton } from '@blueprintnyc/bpnyc-common-admin';
import { Download } from '@blueprintnyc/bpnyc-common-admin/dist/icons';
import fetch from '../../fetch';
import config from '../../config';

export const baseURL = `${config.serverUrl}/api/admin`;

export const handleCSVDownload = (url, name, event) => async () => {
	try {
		const res = await fetch(url);
		if (!res.ok) throw new Error(`CSV download failed with ${res.status}`);
		const text = await res.text();

		// CREATE CSV STANDARD TITLE FORMAT
		const capitalName = name ? name.charAt(0).toUpperCase() + name.slice(1) : name;
		const eventName = event ? `${event}_` : '';
		const csvTitle = `${eventName}${capitalName}_${moment(new Date()).format('MM/DD/YYYY')}`;
		const encodedText = encodeURIComponent(text);

		//utf BOM - necessary for emojis
		var dataStr = 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodedText;

		var downloadAnchorNode = document.createElement('a');
		downloadAnchorNode.setAttribute('href', dataStr);
		downloadAnchorNode.setAttribute('download', `${csvTitle}.csv`);
		document.body.appendChild(downloadAnchorNode); // required for firefox
		downloadAnchorNode.click();
		downloadAnchorNode.remove();
	} catch (e) {
		notification.error({
			message: 'Oops!',
			description: `Failed to download ${name}`,
		});
	}
};

export const getCSVDownloadOnClick = ({
	eventName,
	clientID,
	eventID,
	groupID,
	agendaID,
	name = 'attendees',
}) => {
	const url = getURL(name, clientID, eventID, groupID, agendaID);
	return url ? handleCSVDownload(url, name, eventName) : null;
};

const getURL = (name, clientID, eventID, groupID, agendaID, leaderboardID, checklistID) => {
	let url;
	const baseClientURL = `${baseURL}/clients/${clientID}/events/${eventID}`;
	const baseEventURL = `${baseURL}/events/${eventID}`;
	if (name.endsWith('_Session_Attendees') && agendaID) {
		url = `${baseClientURL}/agendas/${agendaID}/download`;
	} else if (name.endsWith('_Client_Attendees')) {
		url = `${baseURL}/clients/${clientID}/attendees/download`;
	} else if (name.endsWith('_Group') && groupID) {
		url = `${baseURL}/clients/${clientID}/groups/${groupID}/attendees/download`;
	} else if (name.includes('Leaderboard_Attendees') && leaderboardID) {
		url = `${baseURL}/leaderboards/${leaderboardID}/attendees`;
	} else if (name.includes('Leaderboard_Teams') && leaderboardID) {
		url = `${baseURL}/leaderboards/${leaderboardID}/teams`;
	} else {
		switch (name) {
			case 'PointTotals':
				url = `${baseEventURL}/totalpoints`;
				break;
			case 'PointsFeed':
				url = `${baseEventURL}/points`;
				break;
			case 'AvatarPoints':
				url = `${baseEventURL}/avatarpoints`;
				break;
			case 'LoginPoints':
				url = `${baseEventURL}/loginpoints`;
				break;
			case 'Agenda':
				url = `${baseClientURL}/agendas/download`;
				break;
			case 'AgendaGroups':
				url = `${baseClientURL}/agendas/groups/download`;
				break;
			case 'CheckIns':
				url = `${baseClientURL}/checkIns/download`;
				break;
			case 'Connections':
				url = `${baseClientURL}/connections/download`;
				break;
			case 'ConnectionsLeaderboard':
				url = `${baseClientURL}/connectionsleaderboard/download`;
				break;
			case 'GroupBulk':
				url = `${baseClientURL}/groups/download`;
				break;
			case 'Podcasts':
				url = `${baseEventURL}/podcasts`;
				break;
			case 'SyncReport':
				url = `${baseClientURL}/report/download`;
				break;
			case 'DeviceReport':
				url = `${baseClientURL}/devices/download`;
				break;
			case 'SocialPosts':
				url = `${baseClientURL}/posts/download`;
				break;
			case 'Checklist':
				url = `${baseClientURL}/checklists/${checklistID}/download`;
				break;
			default:
				url = `${baseClientURL}/attendees/download`;
		}
	}
	return url;
};

const CSVDownload = ({
	currentClient,
	currentEvent,
	groupID,
	agendaID,
	leaderboardID,
	checklistID,
	fileName,
	disabled,
	size,
	antdSize,
	text,
	name = 'attendees',
	showEventName = true,
}) => {
	const url = getURL(
		name,
		currentClient.id,
		currentEvent.id,
		groupID,
		agendaID,
		leaderboardID,
		checklistID
	);
	if (!url) {
		return <Fragment />;
	}
	const onClick = handleCSVDownload(
		url,
		fileName || name,
		showEventName ? currentEvent.name : null
	);
	if (antdSize) {
		return (
			<Button size={antdSize} icon={<DownloadOutlined />} disabled={disabled} onClick={onClick}>
				{text || 'Download CSV'}
			</Button>
		);
	}
	return (
		<HeaderButton
			className="CSVDownload"
			icon={<Download />}
			type="secondary"
			size={size}
			disabled={disabled}
			onClick={onClick}
		>
			{text ? text : 'Download CSV'}
		</HeaderButton>
	);
};

const msp = ({ events, clients }) => ({
	currentEvent: events.currentEvent,
	currentClient: clients.currentClient,
});

const mdp = () => ({});

export default connect(msp, mdp)(CSVDownload);
